import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  CREATE_FORMS_FILTERS,
  CREATE_STATISTICS,
  EMPLOYEE_DETAILS_UPDATE,
  EMPLOYEE_REMINDERS_PRE_SEND,
  EMPLOYEE_REMINDERS_SEND,
  FORMS_FILTERS,
  GET_JOB_LOG,
  GET_JOBS_LOGS_LIST,
  GET_QUARTZ_INFO,
  GET_SYSTEM_CACHE_LIST,
  MAINTENANCE_PAGE,
  PAUSE_QUARTZ_TRIGGER,
  PROCESS_COMPARE_REQUEST,
  PROCESS_COMPARE_REQUESTS,
  PROCESS_COMPARE_REQUESTS_ERRORS,
  PROCESS_COMPARE_REQUESTS_LOADING,
  QUARTZ_INFO,
  REFRESH_APPLICATION_USER_VIEW,
  RELOAD_CACHE,
  RESUME_QUARTZ_TRIGGER,
  RUN_FORM_101_PDF_COMSIGN_JOB,
  RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS,
  RUN_FORM_101_PDF_FILES_EXPORT_JOB,
  RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS,
  RUN_FORM_101_PDF_GENERATOR_JOB,
  RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS,
  SET_FORMS_FILTERS,
  SET_PROCESS_COMPARE_REQUEST,
  SET_PROCESS_COMPARE_REQUESTS_ERRORS,
  SET_PROCESS_COMPARE_REQUESTS_LOADING,
  SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS,
  SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS,
  SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS,
  SET_SYSTEM_ERRORS,
  SET_SYSTEM_JOBS_ERRORS,
  SET_SYSTEM_QUARTZ_ERRORS,
  SET_SYSTEM_STATISTICS_ERRORS,
  SET_TEST_MAILS_ERRORS,
  STANDBY_QUARTZ_SCHEDULER,
  START_QUARTZ_SCHEDULER,
  SYSTEM_CACHE_LIST,
  SYSTEM_ERRORS,
  SYSTEM_INFO_ACCESSIBLE,
  SYSTEM_JOBS_ERRORS,
  SYSTEM_JOBS_LOGS_LIST,
  SYSTEM_QUARTZ_ERRORS,
  SYSTEM_STATISTICS_ERRORS,
  TEST_MAILS,
  TEST_MAILS_ERRORS,
  STATISTICS_REPORT,
  STATISTICS_REPORT_ERRORS,
  UPDATE_FORM_101_FILTERS,
  REFRESH_INDEX_DATA_BASE, SET_STATISTICS_REPORT_ERRORS,
} from '@/types/system.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Jobs } from '@/models/system/Jobs';
import { QuartzInfo, Trigger } from '@/models/system/QuartzInfo';
import { FormsFiltersModel } from '@/models/system/FormsFilters';
import { GridColumn } from '@/models/GridColumn.model';
import { ClickColumn } from '@/models/ClickColumn.model';
import { JobsObject } from '@/models/system/JobsObject';
import { RunForm101PdfJobRequest } from '@/models/system/RunForm101PdfJobRequest';
import { TestMailsRequest } from '@/models/system/TestMailsRequest';
import { ProcessCompareRequest } from '@/models/system/process-compare-request';
import { StatisticsReportRequest } from '@/models/system/StatisticsReportRequest';

@Component({})
export default class SystemInfoPageComponent extends Vue {

  @Inject() public $validator: any;

  @Action(GET_SYSTEM_CACHE_LIST, StoreNamespace.SYSTEM) public getSystemCacheList;
  @Action(GET_JOBS_LOGS_LIST, StoreNamespace.SYSTEM) public getJobsLogsList;
  @Action(GET_JOB_LOG, StoreNamespace.SYSTEM) public getJobLog;
  @Action(RELOAD_CACHE, StoreNamespace.SYSTEM) public reloadCache;
  @Action(GET_QUARTZ_INFO, StoreNamespace.SYSTEM) public getQuartzInfo;
  @Action(PAUSE_QUARTZ_TRIGGER, StoreNamespace.SYSTEM) public pauseQuartzTrigger;
  @Action(RESUME_QUARTZ_TRIGGER, StoreNamespace.SYSTEM) public resumeQuartzTrigger;
  @Action(START_QUARTZ_SCHEDULER, StoreNamespace.SYSTEM) public startQuartzScheduler;
  @Action(STANDBY_QUARTZ_SCHEDULER, StoreNamespace.SYSTEM) public standbyQuartzScheduler;
  @Action(CREATE_FORMS_FILTERS, StoreNamespace.SYSTEM) public createFormsFilters;
  @Action(CREATE_STATISTICS, StoreNamespace.SYSTEM) public createStatistics;
  @Action(RUN_FORM_101_PDF_GENERATOR_JOB, StoreNamespace.SYSTEM) public runForm101PdfGeneratorJob;
  @Action(RUN_FORM_101_PDF_FILES_EXPORT_JOB, StoreNamespace.SYSTEM) public runForm101PdfFilesExportJob;
  @Action(RUN_FORM_101_PDF_COMSIGN_JOB, StoreNamespace.SYSTEM) public runForm101PdfComsignJob;
  @Action(EMPLOYEE_REMINDERS_SEND, StoreNamespace.SYSTEM) public employeeRemindersSend;
  @Action(EMPLOYEE_REMINDERS_PRE_SEND, StoreNamespace.SYSTEM) public employeeRemindersPreSend;
  @Action(TEST_MAILS, StoreNamespace.SYSTEM) public testMails;
  @Action(STATISTICS_REPORT, StoreNamespace.SYSTEM) public statisticsReport;
  @Action(EMPLOYEE_DETAILS_UPDATE, StoreNamespace.SYSTEM) public employeeDetailsUpdate;
  @Action(PROCESS_COMPARE_REQUESTS, StoreNamespace.SYSTEM) public processCompareRequests;
  @Action(SYSTEM_INFO_ACCESSIBLE, StoreNamespace.SYSTEM) public systemInfoAccessible;
  @Action(REFRESH_APPLICATION_USER_VIEW, StoreNamespace.SYSTEM) public refreshApplicationUserView;
  @Action(MAINTENANCE_PAGE, StoreNamespace.SYSTEM) public maintenancePage;
  @Action(UPDATE_FORM_101_FILTERS, StoreNamespace.SYSTEM) public updateForm101Filters;
  @Action(REFRESH_INDEX_DATA_BASE, StoreNamespace.SYSTEM) public refreshIndexDatabase;

  @Mutation(SET_FORMS_FILTERS, StoreNamespace.SYSTEM) public setFormsFilters;
  @Mutation(SET_SYSTEM_ERRORS, StoreNamespace.SYSTEM) public setSystemErrors;
  @Mutation(SET_SYSTEM_QUARTZ_ERRORS, StoreNamespace.SYSTEM) public setSystemQuartzErrors;
  @Mutation(SET_SYSTEM_JOBS_ERRORS, StoreNamespace.SYSTEM) public setSystemJobsErrors;
  @Mutation(SET_SYSTEM_STATISTICS_ERRORS, StoreNamespace.SYSTEM) public setSystemStatisticsErrors;
  @Mutation(SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS, StoreNamespace.SYSTEM) public setRunForm101PdfGeneratorJobErrors;
  @Mutation(SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS, StoreNamespace.SYSTEM)
  public setRunForm101PdfFilesExportJobErrors;
  @Mutation(SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS, StoreNamespace.SYSTEM) public setRunForm101PdfComsignJobErrors;
  @Mutation(SET_TEST_MAILS_ERRORS, StoreNamespace.SYSTEM) public setTestMailsErrors;
  @Mutation(SET_STATISTICS_REPORT_ERRORS, StoreNamespace.SYSTEM) public setStatisticsReportErrors;
  @Mutation(SET_PROCESS_COMPARE_REQUEST, StoreNamespace.SYSTEM) public setProcessCompareRequest;
  @Mutation(SET_PROCESS_COMPARE_REQUESTS_ERRORS, StoreNamespace.SYSTEM) public setProcessCompareRequestsErrors;
  @Mutation(SET_PROCESS_COMPARE_REQUESTS_LOADING, StoreNamespace.SYSTEM) public setProcessCompareRequestsLoading;

  @Getter(SYSTEM_CACHE_LIST, StoreNamespace.SYSTEM) public systemCacheList!: string[];
  @Getter(SYSTEM_JOBS_LOGS_LIST, StoreNamespace.SYSTEM) public systemJobsLogsList!: Jobs[];
  @Getter(QUARTZ_INFO, StoreNamespace.SYSTEM) public quartzInfo!: QuartzInfo;
  @Getter(FORMS_FILTERS, StoreNamespace.SYSTEM) public formsFilters!: FormsFiltersModel;
  @Getter(SYSTEM_ERRORS, StoreNamespace.SYSTEM) public systemErrors!: string[];
  @Getter(SYSTEM_QUARTZ_ERRORS, StoreNamespace.SYSTEM) public systemQuartzErrors!: string[];
  @Getter(SYSTEM_JOBS_ERRORS, StoreNamespace.SYSTEM) public systemJobsErrors!: string[];
  @Getter(SYSTEM_STATISTICS_ERRORS, StoreNamespace.SYSTEM) public systemStatisticsErrors!: string[];
  @Getter(RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS, StoreNamespace.SYSTEM)
  public runForm101PdfGeneratorJobErrors!: string[];
  @Getter(RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS, StoreNamespace.SYSTEM)
  public runForm101PdfFilesExportJobErrors!: string[];
  @Getter(RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS, StoreNamespace.SYSTEM)
  public runForm101PdfComsignJobErrors!: string[];
  @Getter(TEST_MAILS_ERRORS, StoreNamespace.SYSTEM) public testMailsErrors!: string[];
  @Getter(STATISTICS_REPORT_ERRORS, StoreNamespace.SYSTEM) public statisticReportErrors!: string[];
  @Getter(PROCESS_COMPARE_REQUEST, StoreNamespace.SYSTEM) public processCompareRequest!: ProcessCompareRequest;
  @Getter(PROCESS_COMPARE_REQUESTS_ERRORS, StoreNamespace.SYSTEM) public processCompareRequestsErrors!: string[];
  @Getter(PROCESS_COMPARE_REQUESTS_LOADING, StoreNamespace.SYSTEM) public processCompareRequestsLoading!: boolean;

  public isSuccess: boolean = false;
  public isFailure: boolean = false;

  // Boolean variables for the Scheduler Information
  public startScheduler: boolean = true;
  public standbyScheduler: boolean = false;

  // The columns of the table
  public columns: GridColumn[] = [];

  public jobs: Jobs = {
    jobId: 0,
    jobName: '',
    status: '',
  };
  public searchJobsObject: JobsObject = {
    pageNumber: 1,
    pageSize: 10,
    sortColumn: 'startDate',
    sortDirection: 'desc',
  };
  public quartz: Trigger = {
    paused: true,
  };
  private runForm101PdfGeneratorJobObj: RunForm101PdfJobRequest = {} as RunForm101PdfJobRequest;
  private runForm101PdfFilesExportJobObj: RunForm101PdfJobRequest = {} as RunForm101PdfJobRequest;
  private runForm101PdfComsignJobObj: RunForm101PdfJobRequest = {} as RunForm101PdfJobRequest;
  private testMailsRequest: TestMailsRequest = {} as TestMailsRequest;
  private statisticsReportRequest: StatisticsReportRequest = {} as StatisticsReportRequest;

  public mounted() {
    this.systemInfoAccessible();

    this.getSystemCacheList();
    this.getQuartzInfo();

    this.systemQuartzErrors = [];
    this.systemJobsErrors = [];
    this.setRunForm101PdfGeneratorJobErrors([]);
    this.setRunForm101PdfFilesExportJobErrors([]);
    this.setRunForm101PdfComsignJobErrors([]);
    this.setProcessCompareRequestsErrors([]);
    this.setProcessCompareRequestsLoading(false);
    this.setTestMailsErrors([]);
    this.setStatisticsReportErrors([]);

    this.initColumns();
  }

  public onRefresh(cacheName: string) {
    this.reloadCache({ cacheName });
  }

  public getJobLogFile(jobId: number, jobDesc: string) {
    this.getJobLog({ jobId, jobDesc });
  }

  public onRowClicked(a) {
    // console.log(a);

    // this.getJobLog({ jobId, jobDesc });
    // this.getJobLog({ jobId });
  }

  public onTdClicked(item, column) {
    switch (column.clickEvent) {
      case 'DOWNLOAD_PDF':
        this.getJobLogFile(item.jobId, item.jobDescription);
        break;
    }
  }

  public playScheduler() {
    this.startQuartzScheduler()
      .then((data) => {
        this.standbyScheduler = true;
        this.startScheduler = false;
      })
      .catch((error) => {
        this.standbyScheduler = false;
        this.startScheduler = true;
      });
  }

  public pauseScheduler() {
    this.standbyQuartzScheduler()
      .then((data) => {
        this.startScheduler = true;
        this.standbyScheduler = false;
      })
      .catch((error) => {
        this.startScheduler = false;
        this.standbyScheduler = true;
      });
  }

  public resumeTrigger(trigger: Trigger) {
    this.resumeQuartzTrigger(trigger.name)
      .then((data) => {
        trigger.paused = false;
      })
      .catch((error) => {
        trigger.paused = true;
      });
  }

  public pauseTrigger(trigger: Trigger) {
    this.pauseQuartzTrigger(trigger.name)
      .then((data) => {
        trigger.paused = true;
      })
      .catch((error) => {
        trigger.paused = false;
      });
  }

  public updateFormsFilters(newVal: any, property: string) {
    this.setFormsFilters({ ...this.formsFilters, [property]: newVal });
  }

  public onCreateFormsFiltersSubmit() {
    this.setSystemJobsErrors([]);
    this.createFormsFilters();
  }

  public onCreateStatisticsSubmit() {
    this.setSystemStatisticsErrors([]);
    this.createStatistics();
  }

  public showJobTab() {
    this.getJobsLogsList(this.searchJobsObject);
  }

  public initColumns() {
    this.columns.push({
      property: 'jobId', header: 'views.systemInfoPage.jobs.jobId', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'jobName', header: 'views.systemInfoPage.jobs.jobName', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'startDate', header: 'views.systemInfoPage.jobs.startDate', hideSorting: true, isStringDate: true,
    } as GridColumn);
    this.columns.push({
      property: 'endDate', header: 'views.systemInfoPage.jobs.endDate', hideSorting: true, isStringDate: true,
    } as GridColumn);
    this.columns.push({
      property: 'status', header: 'views.systemInfoPage.jobs.status', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      clickEvent: 'onRowClicked',
    } as ClickColumn);
    this.columns.push({
      clickEvent: 'DOWNLOAD_PDF',
      faIconType: 'fal',
      faIcon: 'download',
    } as ClickColumn);

  }

  public onRunForm101PdfGeneratorJob() {
    this.runForm101PdfGeneratorJob(this.runForm101PdfGeneratorJobObj);
  }

  public onRunForm101PdfFilesExportJob() {
    this.runForm101PdfFilesExportJob(this.runForm101PdfFilesExportJobObj);
  }

  public onRunForm101PdfComsignJob() {
    this.runForm101PdfComsignJob(this.runForm101PdfComsignJobObj);
  }

  public onEmployeeRemindersSend() {
    this.employeeRemindersSend();
  }

  public onEmployeeRemindersPreSend() {
    this.employeeRemindersPreSend();
  }

  public onRefreshApplicationUserView() {
    this.refreshApplicationUserView();
  }

  public onUpdateForm101Filters() {
    this.updateForm101Filters();
  }

  public onRefreshIndexDatabase() {
    this.refreshIndexDatabase();
  }

  public onTestMails() {
    this.testMails(this.testMailsRequest);
  }

  public onStatisticsReport() {
    this.statisticsReport(this.statisticsReportRequest);
  }

  public onRecordsPerPageChanged(records: number) {
    this.searchJobsObject.pageSize = records;
    this.getJobsLogsList(this.searchJobsObject);
  }

  public onPageChange(page: number) {
    this.searchJobsObject.pageNumber = page;
    this.getJobsLogsList(this.searchJobsObject);
  }

  public onEmployeeDetailsUpdate(): void {
    this.employeeDetailsUpdate();
  }

  public onSetProcessCompareRequest(newVal: number, property: string): void {
    this.setProcessCompareRequest({ ...this.processCompareRequest, [property]: newVal });
  }

  public onProcessCompareRequests(): void {
    this.$validator.validateAll('processCompareRequestForm').then((success: boolean) => {
      if (success) {
        this.processCompareRequests(this.processCompareRequest);
        return;
      }

      this.setProcessCompareRequestsLoading(false);
    });
  }

  public onMaintenancePage(turnOnOrOff: boolean): void {
    this.maintenancePage(turnOnOrOff);
  }

}

